import Marquee from "react-fast-marquee";
import { useTranslation } from "react-i18next";
import { Divider } from "retro-react";

function HeaderSection() {
  const { t } = useTranslation();

  return (
    <div id="top">
      <Marquee
        style={{
          color: "cyan",
          fontSize: 20,
        }}
      >
        {t("rollingTitle")}
      </Marquee>
      <header>
        <h1>{t("title")}</h1>
      </header>
      <video
        src="/images/byebyebye.mp4"
        autoPlay
        loop
        muted
        playsInline
        className="gif"
      />
    </div>
  );
}

export default HeaderSection;
